import { Heading, Text } from "@otrium/atoms";
import { Flex } from "@otrium/core";
import Image from "next/image";
import { theme } from "src/theme";
import type { StorefrontCollectionInfo } from "src/types/graphql.d";
import { StyledCollectionsCoverContainer } from "../ProductListingView.styled";

type CollectionsHeaderProps = {
  collection: StorefrontCollectionInfo;
};

function CollectionsHeader({
  collection,
}: CollectionsHeaderProps): React.ReactElement {
  return (
    <>
      {collection.desktopImage ? (
        <StyledCollectionsCoverContainer
          className="desktop"
          minimizeHeightOnMobile={true}
        >
          <Image
            fill
            src={collection.desktopImage}
            alt={`${collection.name} banner`}
          />
        </StyledCollectionsCoverContainer>
      ) : null}

      {collection.mobileImage ? (
        <StyledCollectionsCoverContainer
          className="mobile"
          minimizeHeightOnMobile={true}
        >
          <Image
            fill
            src={collection.mobileImage}
            alt={`${collection.name} banner`}
          />
        </StyledCollectionsCoverContainer>
      ) : null}

      {collection.title ? (
        <Flex
          flexDirection="column"
          alignItems="center"
          backgroundColor="tone.sand"
          padding={["space24", "space24", "space32"]}
          gap={theme.space.space8}
        >
          <Heading
            as="h1"
            variant="h2"
            fontFamily="PlusJakartaSans"
            fontWeight="700"
            fontSize={["fontSize24", "fontSize24", "fontSize32"]}
            lineHeight={["32px", "40px"]}
            textAlign="center"
          >
            {collection.title}
          </Heading>
          {collection.subtitle && (
            <Text
              fontSize="fontSize16"
              color="tone.black"
              lineHeight="24px"
              textAlign="center"
            >
              {collection.subtitle}
            </Text>
          )}
        </Flex>
      ) : null}
    </>
  );
}

export { CollectionsHeader };
